import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../../../assets/logo/logo.png";

const Menubar = () => {
  const menuItems = (
    <React.Fragment>
      <li className="text-center sm:text-secondary md:text-secondary lg:text-success">
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive
              ? "text-success rounded font-semibold text-sm"
              : " text-white font-medium text-sm"
          }
        >
          MEET ME
        </NavLink>
      </li>
      <li className="text-center sm:text-secondary md:text-secondary lg:text-success">
        <NavLink
          to="/blog"
          className={({ isActive }) =>
            isActive
              ? "text-success rounded font-semibold text-sm"
              : " text-white font-medium text-sm"
          }
        >
          BLOGS
        </NavLink>
      </li>
      <li className="text-center sm:text-secondary md:text-secondary lg:text-success">
        <NavLink
          to="/contact"
          className={({ isActive }) =>
            isActive
              ? "text-success rounded font-semibold text-sm"
              : " text-white font-medium text-sm"
          }
        >
          CONTACT
        </NavLink>
      </li>
      <li className="text-center sm:text-secondary md:text-secondary lg:text-success">
        <NavLink
          to="/about"
          className={({ isActive }) =>
            isActive
              ? "text-success rounded font-semibold text-sm"
              : " text-white font-medium text-sm"
          }
        >
          ABOUT
        </NavLink>
      </li>
    </React.Fragment>
  );
  return (
    <div className="bg-primary">
      <div className="navbar py-6 container mx-auto">
        <div className="navbar-start">
          <div className="dropdown">
            <label
              tabIndex={0}
              className="btn btn-ghost btn-circle hover:scale-110 hover:-rotate-1 transition-all ease-in-out delay-75 duration-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h7"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-primary rounded-box w-52"
            >
              {menuItems}
            </ul>
          </div>
        </div>
        <Link to="/" className="navbar-end">
          {/* <Link className="btn btn-ghost normal-case text-xl">
            <span className="text-success font-medium">FARHAN</span>
            <span className="text-success font-semibold">HASIN</span>
            <span className="text-success font-bold">DIPRO</span>
          </Link> */}
          <img
            src={logo}
            alt=""
            className="w-32 hover:scale-110 hover:rotate-2 transition-all ease-in-out delay-75 duration-500"
          />
        </Link>
      </div>
    </div>
  );
};

export default Menubar;
